import { motion } from "framer-motion";
import { CONTACT } from "../../data/site";

export const WhatsAppButton = () => {
  return (
    <motion.a
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Contattaci su WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="animate-wa-pulse fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg"
    >
      <svg
        viewBox="0 0 32 32"
        className="h-7 w-7 fill-white"
        aria-hidden="true"
      >
        <path d="M16.003 3C9.383 3 4 8.383 4 15.003c0 2.114.553 4.174 1.605 5.996L4 29l8.2-1.57a11.94 11.94 0 0 0 3.803.62h.001C22.62 28.05 28 22.667 28 16.047 28 9.427 22.62 4.044 16.003 3zm6.99 16.94c-.29.815-1.69 1.56-2.343 1.657-.6.09-1.36.128-2.196-.137-.506-.16-1.155-.375-1.986-.734-3.494-1.51-5.777-5.03-5.95-5.263-.174-.232-1.42-1.886-1.42-3.598 0-1.712.9-2.553 1.219-2.902.29-.318.68-.398.906-.398.226 0 .453.002.65.012.208.01.487-.079.762.582.29.696.986 2.408 1.073 2.582.087.174.145.377.029.61-.116.232-.174.377-.348.58-.174.203-.366.454-.523.61-.174.174-.356.363-.153.712.203.348.9 1.485 1.933 2.405 1.328 1.184 2.448 1.55 2.796 1.724.348.174.552.145.756-.087.203-.232.87-1.015 1.102-1.363.232-.348.464-.29.784-.174.319.116 2.03.957 2.378 1.13.348.174.58.26.667.406.087.145.087.843-.203 1.658z" />
      </svg>
    </motion.a>
  );
};
